import { render, staticRenderFns } from "./DataCenter.vue?vue&type=template&id=46446f23&scoped=true&"
var script = {}
import style0 from "./DataCenter.vue?vue&type=style&index=0&id=46446f23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46446f23",
  null
  
)

export default component.exports